import View from '@modul-connect/shared/components/atoms/view'
import theme from '../../../theme'

export const SegmentedSelector = ({ options, value, onChange, extend = {}, selectMultiple = false }) => {
  
  const handleClick = (clickedValue) => {
    if (!selectMultiple) return onChange(clickedValue)
  
    const currentValues = value ?? []
    const newValues = currentValues.includes(clickedValue)
      ? currentValues.filter(v => v !== clickedValue)
      : [...currentValues, clickedValue]
  
    onChange(newValues)
  }

  return (
    <View extend={{ ...styles.group, ...(extend.group ) }}>
      {options.map((option, index) => {
        const isActive = selectMultiple
  ? value && value.includes(option.value)
  : value === option.value

        return (
          <View
            key={option.value}
            extend={{
              ...styles.option,
              ...(index === 0 && styles.option_first ),
              ...(index > 0 && styles.option_middle ),
              ...(index === options.length - 1 && styles.option_last ),
              ...(isActive && styles.option_active ),
              ...(extend.option),
              ...(isActive && extend.option_active),
            }}
            onClick={() => handleClick(option.value)}
          >
            <span>{option.label}</span>
          </View>
        )
      })}
    </View>
  )
}

const styles = {
  group: {
    display: 'flex',
    flexDirection: 'row',
    width: 276,
    height: 27,
    border: `1px solid ${theme.colors.uiBorderColor}`,
    borderRadius: 4,
    overflow: 'hidden',
  },

  option: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 12px',
    gap: 16,
    cursor: 'pointer',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: 16,
    lineHeight: '19px',
    color: '#646464',
  },

  option_first: {
    borderRight: `1px solid ${theme.colors.uiBorderColor}`,
  },

  option_middle: {
    borderRight: `1px solid ${theme.colors.uiBorderColor}`,
  },

  option_last: {
    borderRight: 'none',
  },

  option_active: {
    background: '#3D5DAF',
    color: '#FFFFFF',
    border: `1px solid ${theme.colors.downloadBlue}`,
  },
}